import React from 'react';
import gql from 'graphql-tag';
import Helmet from 'react-helmet';
import { Container, Row, Col } from 'react-bootstrap';
import Hyper from '../../../src/admin/layout/components/Hyper';
import IntegrationTable from '../../containers/IntegrationTable';
import styles from './styles.scss';

const Integrations = ({ integrations }) => (
  <Hyper title="Integrations" activeItem="integrations">
    <Helmet title="Integrations" />
    <Container fluid>
      <Row>
        <Col className={styles.headingContainer} xs={12}>
          <span className={styles.heading}>Integration Alerts</span>
        </Col>
      </Row>
      <Row>
        {integrations.map(integration => (
          <IntegrationTable integration={integration} />
        ))}
      </Row>
    </Container>
  </Hyper>
);

Integrations.fragments = {
  integrations: gql`
    fragment IntegrationsIntegrationFields on Integration {
      id
      ...IntegrationTableIntegration
    }

    ${IntegrationTable.fragments.integration}
  `,
};

export default Integrations;
